import type { moderation as en } from "../en/moderation";
import type { Messages } from "../types";

export const moderation: Messages<typeof en> = {
  title: "الإشراف",
  flags: {
    spam: "مزعج",
    important: "مهم",
    follow_up: "للمتابعة",
    lead: "عميل محتمل",
    complaint: "شكوى",
    vip: "مميز",
  },
  flagMenu: {
    label: "الوسوم",
    trigger: "وسم",
    builtIn: "الوسوم الجاهزة",
    custom: "وسومك",
    search: "ابحث عن وسم أو أنشئ واحداً…",
    create: "إنشاء الوسم «\u2068{{label}}\u2069»",
    created: "تم إنشاء الوسم «\u2068{{label}}\u2069»",
    noCustom: "لا توجد وسوم خاصة بعد",
    manage: "إدارة الوسوم",
    failed: "تعذّر تحديث الوسوم",
    add: "إضافة الوسم {{flag}}",
    remove: "إزالة الوسم {{flag}}",
  },
  badges: {
    deleted: "محذوف من إنستغرام",
    deletedTip: "حُذف {{when}} {{by}}. عرف ملفك بذلك عبر {{source}}. النص محفوظ.",
    deletedBy: {
      author: "من صاحبه",
      account: "من حسابك",
      platform: "من إنستغرام",
      unknown: "(من حذفه غير معروف)",
    },
    source: {
      webhook: "تحديث مباشر",
      reconcile: "الفحص الدوري",
      malfak: "إجراء منك في منصة ملفك",
    },
    recovered: "مُستعاد",
    recoveredTip: "وجده الفحص الدوري بعد تحديث مباشر فائت، وطُبّقت عليه القواعد كالمعتاد.",
    pinned: "مثبّت",
    archived: "مؤرشف",
    unsent: "أُلغي إرسالها",
    unsentTip: "ألغى الشخص إرسال هذه الرسالة، واحتفظ ملفك بنصها.",
    edited: "معدّلة",
  },
  versions: {
    title: "سجل الرسالة",
    original: "الأصل",
    edit: "التعديل {{n}}",
    unsend: "إلغاء الإرسال",
    show: "عرض السجل",
  },
  marks: {
    harmful: "مؤذٍ",
    troll: "متنمّر معروف",
    vip: "مميز",
    label: "التصنيف",
    markAs: "تصنيف صاحب التعليق",
    clear: "إزالة التصنيف",
    marked: "صُنّف {{mark}}",
    cleared: "أُزيل التصنيف",
    none: "غير مصنّف",
  },
  filters: {
    flag: "وسم",
    anyFlag: "الكل",
    deleted: "المحذوف من إنستغرام",
    archived: "المؤرشف",
    hide: "إخفاء",
    show: "إظهار",
    only: "فقط",
  },
  actions: {
    archive: "أرشفة",
    unarchive: "إلغاء الأرشفة",
    pin: "تثبيت",
    unpin: "إلغاء التثبيت",
    archived: "أُرشف التعليق",
    unarchived: "أُلغيت أرشفة التعليق",
    pinned: "ثُبّت التعليق",
    unpinned: "أُلغي تثبيت التعليق",
    failed: "لم ينجح ذلك",
    flagged: "حُدّثت الوسوم",
    bulkFlag: "وسم المحدد",
    bulkUnflag: "إزالة وسم من المحدد",
    bulkArchive: "أرشفة المحدد",
    bulkUnarchive: "إلغاء أرشفة المحدد",
    archiving_zero: "أرشفة {{count}} تعليق",
    archiving_one: "أرشفة تعليق واحد",
    archiving_two: "أرشفة تعليقين",
    archiving_few: "أرشفة {{count}} تعليقات",
    archiving_many: "أرشفة {{count}} تعليقًا",
    archiving_other: "أرشفة {{count}} تعليق",
    archivedMany_zero: "أُرشف {{count}} تعليق",
    archivedMany_one: "أُرشف تعليق واحد",
    archivedMany_two: "أُرشف تعليقان",
    archivedMany_few: "أُرشف {{count}} تعليقات",
    archivedMany_many: "أُرشف {{count}} تعليقًا",
    archivedMany_other: "أُرشف {{count}} تعليق",
  },
  post: {
    title: "التعليقات",
    reload: "إعادة تحميل التعليقات",
    reloadHint: "يجلب كل تعليقات هذا المنشور من إنستغرام، ويستعيد الفائت منها ويعلّم المحذوف.",
    reloadStarted: "جارٍ إعادة تحميل التعليقات",
    search: "ابحث في التعليقات…",
    smart: "بحث ذكي",
    smartHint: "يبحث بالمعنى: «مشاكل التوصيل» يجد شكاوى تأخر الطلبات.",
    filters: "التصفية",
    clear: "مسح",
    sortLabel: "الترتيب",
    sort: {
      newest: "الأحدث",
      oldest: "الأقدم",
      replies: "الأكثر ردوداً",
      toxicity: "الأكثر إساءة",
    },
    any: "الكل",
    status: "الحالة",
    statusOpts: {
      visible: "ظاهر",
      hidden: "مخفي",
      deleted: "محذوف",
    },
    sentiment: "المشاعر",
    intent: "النية",
    rule: "القاعدة المطبّقة",
    ruleAction: "الإجراء المتخذ",
    replied: "الرد",
    repliedYes: "تم الرد",
    repliedNo: "بلا رد",
    pinnedOnly: "المثبّت فقط",
    pinnedSection: "المثبّت",
    empty: "لا توجد تعليقات بعد",
    emptyHint: "تصل التعليقات الجديدة مباشرة. أعد التحميل لجلب كل شيء من إنستغرام.",
    emptyFiltered: "لا توجد تعليقات مطابقة",
    emptyFilteredHint: "جرّب تصفية أقل أو أوقف البحث الذكي.",
    count_zero: "لا تعليقات",
    count_one: "تعليق واحد",
    count_two: "تعليقان",
    count_few: "{{count}} تعليقات",
    count_many: "{{count}} تعليقًا",
    count_other: "{{count}} تعليق",
    select: "تحديد تعليق ‎@{{name}}",
    selectAll: "تحديد الكل",
    selected_zero: "{{count}} محدد",
    selected_one: "{{count}} محدد",
    selected_two: "{{count}} محدد",
    selected_few: "{{count}} محدد",
    selected_many: "{{count}} محدد",
    selected_other: "{{count}} محدد",
    deselect: "إلغاء التحديد",
    open: "فتح تعليق ‎@{{name}}",
    replies_zero: "لا ردود",
    replies_one: "رد واحد",
    replies_two: "ردّان",
    replies_few: "{{count}} ردود",
    replies_many: "{{count}} ردًا",
    replies_other: "{{count}} رد",
    hideReplies: "إخفاء الردود",
    hide: "إخفاء",
    unhide: "إظهار",
    delete: "حذف",
    deleteTitle_zero: "حذف {{count}} تعليق من إنستغرام؟",
    deleteTitle_one: "حذف تعليق واحد من إنستغرام؟",
    deleteTitle_two: "حذف تعليقين من إنستغرام؟",
    deleteTitle_few: "حذف {{count}} تعليقات من إنستغرام؟",
    deleteTitle_many: "حذف {{count}} تعليقًا من إنستغرام؟",
    deleteTitle_other: "حذف {{count}} تعليق من إنستغرام؟",
    deleteHint: "تُحذف من إنستغرام، وتحتفظ منصة ملفك بنصها مع شارة «محذوف».",
    markDone: "تم",
    flag: "وسم",
    archive: "أرشفة",
    loadMore: "تحميل المزيد",
    bulkRunning_zero: "{{action}}: {{count}} تعليق",
    bulkRunning_one: "{{action}}: تعليق واحد",
    bulkRunning_two: "{{action}}: تعليقان",
    bulkRunning_few: "{{action}}: {{count}} تعليقات",
    bulkRunning_many: "{{action}}: {{count}} تعليقًا",
    bulkRunning_other: "{{action}}: {{count}} تعليق",
    bulkDone: "اكتمل: {{action}}",
  },
  panel: {
    title: "التعليق",
    thread: "المحادثة",
    noReplies: "لا توجد ردود بعد",
    runs: "الأتمتة على هذا التعليق",
    noRuns: "لم تطبّق أي قاعدة على هذا التعليق.",
    runResult: {
      executed: "نُفّذ",
      pending_approval: "بانتظار الموافقة",
      skipped: "تم التجاوز",
      failed: "فشل",
      suggested: "مقترح",
    },
    replyPublic: "رد علني",
    replyPrivate: "رد خاص",
    privateUntil: "الرد الخاص متاح حتى {{date}}",
    privateUsed: "أُرسل رد خاص بالفعل (يسمح إنستغرام برد واحد لكل تعليق).",
    privateExpired: "الرد الخاص متاح خلال 7 أيام من التعليق فقط.",
    privateUnavailable: "الرد الخاص غير متاح لهذا التعليق.",
    placeholder: "اكتب رداً…",
    send: "إرسال",
    sent: "الرد في الطريق",
    sentPrivate: "الرد الخاص في الطريق",
    hide: "إخفاء",
    unhide: "إظهار",
    hidden: "أُخفي التعليق",
    unhidden: "عاد التعليق ظاهراً",
    delete: "حذف",
    deleteConfirm: "حذف هذا التعليق من إنستغرام؟",
    deleteHint: "يُحذف من إنستغرام، وتحتفظ منصة ملفك بنصه مع شارة «محذوف».",
    deleted: "حُذف التعليق",
    onPost: "على هذا المنشور",
    viewOnInstagram: "عرض على إنستغرام",
    openInbox: "فتح في صندوق الوارد",
    deletedNotice: "حُذف هذا التعليق من إنستغرام، ونصه محفوظ هنا.",
  },
  commenter: {
    title: "صاحب التعليق",
    openProfile: "فتح الملف على إنستغرام",
    fetchProfile: "جلب الملف",
    fetching: "جارٍ جلب الملف…",
    refetch: "تحديث الملف",
    fetchStarted: "جارٍ جلب الملف العام",
    followers_zero: "{{count}} متابع",
    followers_one: "متابع واحد",
    followers_two: "متابعان",
    followers_few: "{{count}} متابعين",
    followers_many: "{{count}} متابعًا",
    followers_other: "{{count}} متابع",
    posts_zero: "{{count}} منشور",
    posts_one: "منشور واحد",
    posts_two: "منشوران",
    posts_few: "{{count}} منشورات",
    posts_many: "{{count}} منشورًا",
    posts_other: "{{count}} منشور",
    fetchedAt: "جُلب الملف {{when}}",
    source: {
      business_discovery: "الملف العام على إنستغرام",
      user_profile: "واجهة ملف إنستغرام",
      none: "غير متاح",
    },
    noProfile: "لم يُجلب الملف بعد. يشارك إنستغرام ملفات حسابات الأعمال وصنّاع المحتوى العامة فقط، أو من راسلوك.",
    counts: {
      comments: "التعليقات",
      negative: "سلبي",
      toxic: "مسيء",
      spam: "مزعج",
      flagged: "معلّم",
      hidden: "مخفي",
      deleted: "محذوف",
      archived: "مؤرشف",
    },
    archiveAll: "أرشفة كل تعليقاته",
    hideAll: "إخفاء كل تعليقاته",
    archiveAllConfirm: "أرشفة كل تعليقات ‎@{{name}}؟",
    hideAllConfirm: "إخفاء كل تعليقات ‎@{{name}} على إنستغرام؟",
    archiveAllHint: "تخرج التعليقات المؤرشفة من العرض الافتراضي، ويمكنك إلغاء الأرشفة لاحقاً.",
    hideAllHint: "يراها صاحبها فقط. تُنفّذ كمهمة في الخلفية.",
    openContact: "فتح الملف الشخصي",
    verified: "موثّق",
    followsYou: "يتابعك",
  },
  people: {
    title: "الأشخاص",
    description: "كل من علّق على الحساب، مع أرقام الإشراف.",
    account: "الحساب",
    search: "ابحث عن شخص…",
    sortLabel: "الترتيب",
    sort: {
      recent: "الأحدث",
      comments: "الأكثر تعليقاً",
      negative: "الأكثر سلبية",
      toxic: "الأكثر إساءة أو إزعاجاً",
    },
    markFilter: "التصنيف",
    markOpts: {
      all: "الجميع",
      any: "المصنّفون",
      harmful: "مؤذون",
      troll: "متنمّرون معروفون",
      vip: "مميزون",
      none: "غير مصنّفين",
    },
    empty: "لا يوجد معلّقون بعد",
    emptyHint: "يظهر الأشخاص هنا عندما يعلّقون على هذا الحساب.",
    emptyFiltered: "لا يوجد أحد مطابق",
    last: "آخر تعليق {{when}}",
    actions: "إجراءات ‎@{{name}}",
    count_zero: "{{count}} شخص",
    count_one: "شخص واحد",
    count_two: "شخصان",
    count_few: "{{count}} أشخاص",
    count_many: "{{count}} شخصًا",
    count_other: "{{count}} شخص",
  },
  contactData: {
    title: "البيانات الشخصية",
    hint: "صدّر كل ما يحفظه ملفك عن هذا الشخص أو امسحه. للمشرفين والمالكين فقط، ويُسجَّل كلاهما.",
    export: "تصدير البيانات (JSON)",
    exported: "نُزّل ملف التصدير",
    delete: "حذف البيانات",
    deleteTitle: "مسح كل بيانات {{name}}؟",
    deleteHint: "يحذف الشخص وتعليقاته ومحادثاته ورسائله ووسومه من منصة ملفك، ولا يحذف شيئًا من إنستغرام. لا يمكن التراجع.",
    typeToConfirm: "اكتب {{name}} للتأكيد",
    deleted: "مُسحت بيانات جهة الاتصال",
    adminOnly: "التصدير والمسح للمشرفين والمالكين فقط.",
    flags: "الوسوم",
    profile: "الملف العام",
  },
  tags: {
    title: "الوسوم والفئات الذكية",
    hint: "تعمل الوسوم الجاهزة ووسومك على التعليقات والمحادثات والأشخاص، ويمكن للقواعد إضافتها أيضًا.",
    builtIn: "الوسوم الجاهزة",
    custom: "وسوم خاصة",
    count_zero: "{{count}} عنصر",
    count_one: "عنصر واحد",
    count_two: "عنصران",
    count_few: "{{count}} عناصر",
    count_many: "{{count}} عنصرًا",
    count_other: "{{count}} عنصر",
    newTag: "وسم جديد",
    label: "الاسم",
    labelPlaceholder: "مثلاً: جملة",
    color: "اللون",
    create: "إنشاء الوسم",
    created: "أُنشئ الوسم",
    save: "حفظ",
    saved: "حُفظ الوسم",
    rename: "تعديل {{label}}",
    delete: "حذف {{label}}",
    deleteTitle: "حذف الوسم «\u2068{{label}}\u2069»؟",
    deleteHint: "يُزال من كل تعليق ومحادثة وشخص.",
    deleted: "حُذف الوسم",
    adminOnlyDelete: "حذف الوسوم للمشرفين فقط",
    empty: "لا توجد وسوم خاصة بعد",
    emptyHint: "أنشئ وسوماً مثل «جملة» أو «مؤثر» لتنظيم صندوق الوارد.",
    key: "المفتاح: {{key}}",
    sections: "أنواع التصنيفات",
    tabTags: "الوسوم",
    tabCategories: "فئات الذكاء الاصطناعي",
    categoriesHint: "تصنيفاتك الخاصة (مثل إيجابي، سلبي، يريد استرداداً). يصنّف الذكاء الاصطناعي التعليقات الجديدة بها مع درجة ثقة، ويمكن للقواعد استخدام «فئة الذكاء الاصطناعي هي …».",
    newCategory: "فئة ذكاء اصطناعي جديدة",
    createCategory: "إنشاء الفئة",
    categoryEmpty: "لا توجد فئات ذكاء اصطناعي بعد",
    categoryEmptyHint: "صِف التصنيف بكلمات بسيطة وأعطِ بعض الأمثلة، والذكاء الاصطناعي يتكفل بالباقي.",
    description: "الوصف",
    descriptionPlaceholder: "مثلاً: العميل سعيد بالمنتج",
    examples: "أمثلة",
    examplesPlaceholder: "اكتب مثالاً ثم اضغط Enter",
    scope: "ينطبق على",
    allAccounts: "كل الحسابات",
    minConfidence: "الوسم عند درجة ثقة",
    categoryBadge: "فئة ذكاء اصطناعي",
    noDescription: "بلا وصف",
  },
};
